import { motion } from 'framer-motion';
import styled from 'styled-components';

import { Link } from '@littleotter/zz-legacy-components';

import { careDenProxyUrl } from '$shared/utils/proxy';

import { routes } from '../../routes';

const listVariants = {
  open: {
    opacity: 1,
    x: 0,
    transition: { staggerChildren: 0.05, delayChildren: 0.2 },
  },
  closed: {
    opacity: 0,
    x: '100%',
    transition: { when: 'afterChildren', staggerChildren: 0.02, staggerDirection: -1 },
  },
};

const listItemVariants = {
  open: { opacity: 1, x: 0 },
  closed: { opacity: 0, x: '100%' },
};

const StyledNavLinks = styled(motion.ul)`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.deprecated_.colors.white};
  border-left: ${({ theme }) =>
    `${theme.deprecated_.border.size} ${theme.deprecated_.border.style} ${theme.deprecated_.border.color}`};

  li {
    width: 100%;
    text-align: center;
    border-bottom: ${({ theme }) =>
      `${theme.deprecated_.border.size} ${theme.deprecated_.border.style} ${theme.deprecated_.border.color}`};
    padding: ${({ theme }) => theme.deprecated_.sizeBasis} 0;
    font-size: 20px;
  }

  li:last-child {
    border-bottom: none;
  }
`;

export const NavLinks = () => {
  return (
    <StyledNavLinks variants={listVariants}>
      <motion.li variants={listItemVariants}>
        <Link href={routes.provider.home.url()} target="_self">
          Provider Home
        </Link>{' '}
        | <Link href={careDenProxyUrl}>Care Den</Link>
      </motion.li>
    </StyledNavLinks>
  );
};
